import { useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

/**
 * The assistant opens as a bottom sheet over any client page (?ask=1, optional
 * &q=<question> to send right away). Like the booking sheet it is a history entry,
 * so Back closes it.
 */
export function useAssistantNav() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isOpen = params.get('ask') === '1';
  const question = params.get('q');

  const open = useCallback(
    (q?: string) => {
      const search = new URLSearchParams(params);
      search.set('ask', '1');
      if (q) search.set('q', q);
      else search.delete('q');
      for (const key of ['book', 'svc', 'day', 'at']) search.delete(key);
      window.setTimeout(
        () => navigate({ pathname: location.pathname, search: search.toString() }, { state: { askOpened: true } }),
        0,
      );
    },
    [params, navigate, location.pathname],
  );

  const close = useCallback(() => {
    if ((location.state as { askOpened?: boolean } | null)?.askOpened) {
      window.setTimeout(() => navigate(-1), 0);
      return;
    }
    const search = new URLSearchParams(params);
    search.delete('ask');
    search.delete('q');
    window.setTimeout(() => navigate({ pathname: location.pathname, search: search.toString() }, { replace: true }), 0);
  }, [params, navigate, location]);

  return { isOpen, question, open, close };
}
